let axios = window.axios
export default {
  /* 检查号码重复 */
  check_phone (number, id) {
    return window.axios.get('/erp/api.customer_telephone/check', {
      params: {
        number: number,
        id: id
      }
    })
  },
  // 获取客户号码
  get_telephones (customerId) {
    axios.get('/erp/api.customer_telephone/index?customer_id' + customerId)
  },
  /* 添加客户号码 */
  add_phone (params) {
    return axios.post('/erp/api.customer_telephone/add', params)
  },
  /* 删除客户号码 */
  delete_phone (id) {
    return axios.get('/erp/api.customer_telephone/delete?id=' + id)
  }

}
